import { render, staticRenderFns } from "./PostRequest.vue?vue&type=template&id=a8abeaf8&"
import script from "./PostRequest.vue?vue&type=script&lang=js&"
export * from "./PostRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports